import { Stack } from '@mantine/core'
import React from 'react'

export default function ReportWrapper({ children }: { children: React.ReactNode }) {
  return <Stack gap="xs">{children}</Stack>
}
